// src/services/AuthService.js
import axios from "axios";

const API = process.env.REACT_APP_API;

const signup = async (username, password) => {
    try {
        const { data } = await axios.post(`${API}/signup`, {
            username,
            password
        }, {
            withCredentials: true
        });
        return data;
    } catch (err) {
        console.error("[signup]", err);
        return false;
    }
};

// Login: no persiste datos; entrega toda la información de sesión al AuthProvider.
const login = async (access) => {
    try {
        const { data } = await axios.post(`${API}/login`, access, {
            withCredentials: true,
        });

        if (data?.Login && data?.token) {
            return {
                token: data.token,
                user: data.user ?? null,
                name: data.name ?? null,
                fullName: data.fullName ?? data.name ?? null,
                rol: data.rol ?? null,
                sedeId: data.sedeId ?? null,
                sedeName: data.sedeName ?? null,
                sedeLocation: data.sedeLocation ?? null,
            };
        }
        return false;
    } catch (err) {
        console.error("[login]", err);
        return false;
    }
};

const verifyLogin = async (token) => {
    const t = token || localStorage.getItem("token");
    if (!t) return false;

    try {
        const { data } = await axios.get(`${API}`, {
            headers: { Authorization: `Bearer ${t}` },
            withCredentials: true,
        });
        return data;
    } catch (err) {
        console.warn("[verifyLogin]", err?.response?.status || err?.message);
        return false;
    }
};

const getToken = () => localStorage.getItem("token");

const authService = {
    signup,
    login,
    verifyLogin,
    getToken
};
export default authService;
